import React, {Component} from 'react';
import {
    getDateTypeList
} from "../helper/helper";

class DateTypePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateTypes: getDateTypeList(),
        }
    }

    getClass(dateTypeValue) {
        return ((this.props.selectedDateType === dateTypeValue) ? "selectedYear " : "") + "year btn-primary "
    }

    render() {
        return (
            <div className=" pt-2" >
                <div className="btn-group" role="group" aria-label="Yıllar"
                     style={{marginBottom: '10px', marginLeft: '10px'}}>
                    {this.state.dateTypes.map((dateType, i) =>
                        <button key={i} onClick={e => {
                            this.props.onSetDateType(dateType.value)
                        }}
                                type="button"
                                className={this.getClass(dateType.value)}>
                            {dateType.label}
                        </button>
                    )}

                </div>

            </div>
        );
    }
}

export default DateTypePicker;